import { useState } from 'react';

import { cn } from '@/lib/utils';
import { AssetViewer } from '@/modules/asset-viewer';

import { Asset, SimpleSlideProps } from '../../types';
import { InfoCard } from './components/InfoCard';
import { getGridColumns } from '../../utils/grid-columns';
import { resolveItemAssets } from '../../utils/item-asset-resolver';

export const SimpleSlide = ({ slide, assets, assetsBaseUrl }: SimpleSlideProps) => {
  const [viewerState, setViewerState] = useState<{
    isOpen: boolean;
    assets: Asset[];
    initialIndex: number;
  } | null>(null);

  const gridCols = getGridColumns(slide.items.length);

  const handleOpenViewer = (itemAssets: Asset[], initialIndex: number) => {
    setViewerState({
      isOpen: true,
      assets: itemAssets,
      initialIndex,
    });
  };

  return (
    <>
      <div className="flex h-full w-full items-center justify-center overflow-y-auto px-2 sm:px-4">
        <div className="w-full max-w-5xl py-4 sm:py-6">
          <div className={cn('grid justify-items-center gap-4 sm:gap-6', gridCols)}>
            {slide.items.map((item, itemIndex) => {
              const { assets: itemAssets, title } = resolveItemAssets(item, assets, itemIndex);

              return (
                <InfoCard
                  key={`item-${itemIndex}`}
                  title={title}
                  description={item.description}
                  assets={itemAssets}
                  onOpenViewer={handleOpenViewer}
                  assetsBaseUrl={assetsBaseUrl}
                />
              );
            })}
          </div>
        </div>
      </div>

      {viewerState && (
        <AssetViewer
          isOpen={viewerState.isOpen}
          onClose={() => setViewerState(null)}
          assets={viewerState.assets}
          assetsBaseUrl={assetsBaseUrl}
          initialIndex={viewerState.initialIndex}
        />
      )}
    </>
  );
};
